import React from "react";
import ReactHtmlParser from "react-html-parser";
import {
  Accordion,
  AccordionButton,
  AccordionItem,
  AccordionPanel,
  Box,
  Heading,
  Text,
} from "src/components/UI";
import { ElectronicMoneyData } from "./ElectronicMoneyData";

const ElectronicMoneyAccordion = () => {
  return (
    <Box padding={["0 16px", "0"]}>
      <Accordion>
        {ElectronicMoneyData.map((emoney, index) => {
          return (
            <AccordionItem key={index}>
              <AccordionButton>
                <Box maxWidth="140px" height="58px">
                  <img
                    src={emoney.icon}
                    alt={emoney.title}
                    style={{
                      width: "inherit",
                      height: "inherit",
                      objectFit: "contain",
                    }}
                  />
                </Box>
              </AccordionButton>
              <AccordionPanel padding={["8px 0", "42px 0"]}>
                <Box gap={["32px", "48px"]}>
                  {emoney.sections.map((section, index) => (
                    <Box key={index} gap={["16px", "32px"]}>
                      <Heading
                        fontWeight={700}
                        fontSize={["16px", "20px"]}
                        lineHeight={["24px"]}
                      >
                        {ReactHtmlParser(section.title)}
                      </Heading>
                      <Box
                        as="ul"
                        listStyle="auto"
                        padding={["0 20px", "0 66px"]}
                        gap={["16px", "24px"]}
                      >
                        {section.steps.map((step, index) => (
                          <Box as="li" display="list-item" key={index}>
                            <Text
                              fontFamily="Roboto, sans-serif"
                              fontSize={[14, 16]}
                              fontWeight={[400]}
                              lineHeight={["20px", "24px"]}
                            >
                              {ReactHtmlParser(step)}
                            </Text>
                          </Box>
                        ))}
                      </Box>
                    </Box>
                  ))}
                </Box>
              </AccordionPanel>
            </AccordionItem>
          );
        })}
      </Accordion>
    </Box>
  );
};

export default ElectronicMoneyAccordion;
